/* UPDATED IncidentImagesModal.js for REACT 18, Bootstrap 5, Show Photos 06-20-25 */
import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hideModal } from '../../actions/modal';
import './IncidentImagesModal.css';

const IncidentImagesModal = ({ modalProps = {}, visible, hideModal }) => {
  const modalRef = useRef(null);
  const incident = modalProps.incident || {};
  const images = modalProps.images || [];

  console.log('at photos modal in render to see what props are on incident and images', { modalProps, incident, images, visible });

  // Minimal useEffect for backdrop click
  useEffect(() => {
    const modalElement = modalRef.current;
    if (modalElement && visible) {
      const handleBackdropClick = (e) => {
        if (e.target === modalElement && hideModal) {
          console.log('Backdrop clicked, closing IncidentImagesModal');
          hideModal();
        }
      };
      modalElement.addEventListener('click', handleBackdropClick);
      return () => {
        modalElement.removeEventListener('click', handleBackdropClick);
      };
    }
  }, [visible, hideModal]);

  if (!visible) {
    console.log('IncidentImagesModal not visible, returning null');
    return null;
  }


  // Construct title like "Photos - INC-123 - Description"
  // Construct title like "Photos - INC-123 - title"
  const titleText = incident.title || 'No title';



  return (
    <div>
      {/* Backdrop */}
      <div className="modal-backdrop fade show" />
      {/* Modal */}
      <div
        className={`custom-modal ${visible ? 'show' : ''}`}
        id="image-modal"
        ref={modalRef}
        style={{ display: visible ? 'block' : 'none' }}
      >
        <div className="custom-modal-dialog">
          <div className="custom-modal-content">
            <div className="custom-modal-header">
              <h5 className="custom-modal-title">
              Photos - <span className="display-title">{incident.display_title || 'Incident'}</span>
                {` - ${titleText}`}
              </h5>
              <button type="button" className="custom-modal-close-button" onClick={hideModal}>
                Close X
              </button>
            </div>
            <div className="custom-modal-body" id="image-modal-body">
              {images.length > 0 ? (
                images.map((image, index) => (
                  <img
                    key={index}
                    src={image.url}
                    alt={`Incident photo ${index + 1}`}
                    style={{ maxWidth: '100%', margin: '10px' }}
                  />
                ))
              ) : (
                <p>No photos available</p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

IncidentImagesModal.propTypes = {
  modalProps: PropTypes.object,
  visible: PropTypes.bool.isRequired,
  hideModal: PropTypes.func,
};

const mapStateToProps = (state) => ({
  modalProps: state.modal.modalProps || {},
  visible: state.modal.modalType === 'INCIDENT_IMAGES' && state.modal.visible,
});

export default connect(mapStateToProps, { hideModal })(IncidentImagesModal);